import { request } from '@/api/request';

export type DiscussionPreferences = {
  seenEnabled: boolean;
};

const fetchDiscussionsPreferences = () =>
  request<DiscussionPreferences>('GET', `/discussions/preferences`);

const updateDiscussionsPreferences = (seenEnabled: boolean) =>
  request('PATCH', `/discussions/preferences`, {
    seenEnabled,
  });

export default {
  updateDiscussionsPreferences,
  fetchDiscussionsPreferences,
};
